import { render, staticRenderFns } from "./SelectTypeStep.vue?vue&type=template&id=2cb4c21e"
import script from "./SelectTypeStep.vue?vue&type=script&lang=js"
export * from "./SelectTypeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports